<template>
  <div class="need-list">
    <el-row :gutter="20" v-if="needListRes.length > 0">
      <el-col :span="8" v-for="(it, idx) in needListRes" :key="idx">
        <div class="news_item" @click="fnToNeed(it.demand_id)">
          <el-image :src="it.main_image[0]" fit="cover"></el-image>
          <div class="news_item_info">
            <h3>{{ it.title }}</h3>
            <div class="types red" v-if="it.demand_type == 0">采購</div>
            <div class="types" v-if="it.demand_type == 1">出售轉讓</div>
            <div class="news_item_time">
              <div>{{ $dayjs(it.end_time).format("YYYY-MM-DD") }} 截止</div>
            </div>
          </div>
          <div class="edit-btn">
            <button @click.stop="update(it.demand_id)">修改</button>
            <button class="del" @click.stop="del(it.demand_id)">刪除</button>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="修改" :visible.sync="dialogVisible" width="80%">
      <div>
        <div class="needs-form" v-if="demand_type == 0">
          <el-row>
            <el-col :span="4" class="tag"><i>*</i> 標題：</el-col>
            <el-col :span="16">
              <el-input
                v-model="needsForm.title"
                placeholder="提煉需求內容，比如XXXXXXXX，建議填寫多種標簽名稱，20字以內"
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag"><i>*</i>圖片：</el-col>
            <el-col :span="16">
              <el-upload
                action="https://upload.qiniup.com/"
                :data="qn"
                list-type="picture-card"
                :on-success="handleLogoSuccess"
                :before-upload="beforeAvatarUpload"
                :on-remove="handleRemove"
                :limit="5"
                :file-list="fileList"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <p slot="tip" class="tips">
                  您需要最少上傳 1
                  張圖片用於描述您的需求，建議上傳需求的全貌，最多可上傳 5 張
                </p>
              </el-upload>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag"><i>*</i>采購量：</el-col>
            <el-col :span="16">
              <el-input
                v-model="needsForm.params[0].value"
                placeholder="采購數額（請標明單位）"
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag">截止日期：</el-col>
            <el-col :span="16">
              <el-date-picker
                v-model="needsForm.end_time"
                format="yyyy 年 MM 月 dd 日"
                value-format="timestamp"
                type="date"
                placeholder="采購截止日期"
              >
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag">采購需求：</el-col>
            <el-col :span="16">
              <el-input
                v-model="needsForm.params[1].value"
                placeholder="比如品質、商品規格等要求信息"
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag">交貨需求：</el-col>
            <el-col :span="16">
              <el-input
                v-model="needsForm.params[2].value"
                placeholder="比如交貨方式，交貨地點"
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag">其他：</el-col>
            <el-col :span="16">
              <el-input
                v-model="needsForm.params[3].value"
                placeholder="額外的備註內容（選填）"
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag"><i>*</i>聯系電話：</el-col>
            <el-col :span="16">
              <el-input
                v-model="needsForm.params[4].value"
                placeholder="建議使用您賬號相同的手機號"
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag"></el-col>
            <el-col :span="4" class="tag">
              <el-button type="primary" @click="pubilsh(0)"> 修改 </el-button>
            </el-col>
          </el-row>
        </div>
        <div class="needs-form" v-else>
          <el-row>
            <el-col :span="4" class="tag"><i>*</i>輸入需求地址：</el-col>
            <el-col :span="16">
              <el-input
                v-model="saleForm.addr"
                placeholder="填寫詳細的需求地址 "
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag"><i>*</i>資產名稱：</el-col>
            <el-col :span="16">
              <el-input
                v-model="saleForm.title"
                placeholder="提煉需求內容，比如XXXXXXXX，建議填寫多種標簽名稱，20字以內"
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag"><i>*</i>圖片：</el-col>
            <el-col :span="16">
              <el-upload
                action="https://upload.qiniup.com/"
                :data="qn"
                list-type="picture-card"
                :on-success="handleLogoSuccess2"
                :before-upload="beforeAvatarUpload2"
                :on-remove="handleRemove2"
                :limit="5"
                :file-list="fileList2"
              >
                <i class="el-icon-plus"></i>
                <p slot="tip" class="tips">
                  您需要最少上傳 1
                  張圖片用於描述您的需求，建議上傳需求的全貌，最多可上傳 5 張
                </p>
              </el-upload>
              <!-- <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt="" />
                    </el-dialog> -->n
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag"><i>*</i> 訴求：</el-col>
            <el-col :span="16">
              <el-radio v-model="saleForm.params[0].value" label="出售" border>
                出售
              </el-radio>
              <el-radio v-model="saleForm.params[0].value" label="轉讓" border>
                轉讓
              </el-radio>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag"><i>*</i>價格：</el-col>
            <el-col :span="16">
              <el-col :span="5">
                <el-radio
                  v-model="saleForm.params[1].value"
                  label="價格面議"
                  border
                >
                  價格面議
                </el-radio>
              </el-col>
              <el-col :span="12">
                <el-input
                  v-model="saleForm.params[1].value"
                  placeholder="总价或每平米單價"
                ></el-input>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag">截止日期：</el-col>
            <el-col :span="16">
              <!-- <el-input
                      v-model="saleForm.end_time"
                      placeholder="采購截止日期"
                    ></el-input> -->
              <el-date-picker
                v-model="saleForm.end_time"
                format="yyyy 年 MM 月 dd 日"
                value-format="timestamp"
                type="date"
                placeholder="截止日期"
              >
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag">面積：</el-col>
            <el-col :span="16">
              <el-input
                v-model="saleForm.params[2].value"
                placeholder="比如總建築面積、產證面積"
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag">類型：</el-col>
            <el-col :span="16">
              <el-input
                v-model="saleForm.params[3].value"
                placeholder="比如商場、寫字樓"
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag"><i>*</i>有無商業糾紛：</el-col>
            <el-col :span="16">
              <el-radio v-model="saleForm.params[4].value" label="有" border>
                有
              </el-radio>
              <el-radio v-model="saleForm.params[4].value" label="無" border>
                無
              </el-radio>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag">亮點：</el-col>
            <el-col :span="16">
              <el-input
                v-model="saleForm.params[5].value"
                placeholder="…"
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag">其他：</el-col>
            <el-col :span="16">
              <el-input
                v-model="saleForm.params[6].value"
                placeholder="額外的備註內容（選填）"
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag"><i>*</i>聯系電話：</el-col>
            <el-col :span="16">
              <el-input
                v-model="saleForm.params[7].value"
                placeholder="建議使用您賬號相同的手機號"
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="tag"></el-col>
            <el-col :span="4" class="tag">
              <el-button type="primary" @click="pubilsh(1)">
                修改
              </el-button>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">
          确 定
        </el-button>
      </span> -->
    </el-dialog>
    <!-- <el-button type="info" @click="fnToGetMore">點擊加載更多</el-button> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      needListRes: [],
      start: 0,
      limit: 10,
      dialogVisible: false,
      qn: {
        token: "",
        // key: "avatar_" + Date.now() + "_" + Math.random(),
      },
      needsForm: {
        demand_type: 0,
        title: "",
        main_image: [],
        member_id: this.user_id,
        end_time: "",
        params: [
          {
            name: "采购量",
            value: "",
          },
          {
            name: "采购需求",
            value: "",
          },
          {
            name: "交货需求",
            value: "",
          },
          {
            name: "其他",
            value: "",
          },
          {
            name: "聯系電話",
            value: "",
          },
        ],
        // phone: "",
      },
      saleForm: {
        demand_type: 1,
        title: "",
        addr: "",
        main_image: [],
        member_id: this.user_id,
        end_time: "",
        params: [
          {
            name: "诉求",
            value: "",
          },
          {
            name: "价格",
            value: "",
          },
          {
            name: "面积",
            value: "",
          },
          {
            name: "類型",
            value: "",
          },
          {
            name: "有无商业纠纷",
            value: "",
          },
          {
            name: "亮点",
            value: "",
          },
          {
            name: "其他",
            value: "",
          },
          {
            name: "聯系電話",
            value: "",
          },
        ],
        // phone: "",
      },
      fileList: [],
      fileList2: [],
      demand_type: 0,
      demand_id: "",
    };
  },
  computed: {
    ...mapState(["user_id"]),
  },
  watch: {
    user_id(val) {
      this.getNeedList();
    },
  },
  methods: {
    async getNeedList() {
      let searchJson = {
        member_id: this.user_id,
      };
      const { data: res } = await this.$http.get("/api/v2/demand/list", {
        params: {
          searchJson: searchJson,
          // start: this.start,
          // limit: this.limit,
        },
      });
      if (res.code !== "200") return this.$message.error(res.msg);
      this.needListRes = eval("(" + res.data + ")").data;
      this.needListRes = this.needListRes.map((item) => {
        if (item.main_image) {
          item.main_image = item.main_image.split(",");
          item.end_time = item.end_time.time;
        }
        return item;
      });

      // console.log(JSON.parse(res.data))
      console.log(eval("(" + res.data + ")").data);
      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    fnToNeed(demand_id) {
      console.log(demand_id);
      this.$router.push({
        path: `/need-details/${demand_id}`,
      });
    },
    fnToGetMore() {
      this.start += this.limit;
      this.getNeedList();
    },
    async del(demand_id) {
      const { data: res } = await this.$http.get(
        `/api/v2/demand/delete/${demand_id}`
      );
      if (res.code !== "200") return this.$message.error(res.msg);
      if (res.code == "200")
        this.$message({
          message: "刪除成功",
          type: "success",
        });
      this.getNeedList();
    },
    update(demand_id) {
      this.dialogVisible = true;
      this.getNewsDetails(demand_id);
      this.demand_id = demand_id;
      this.fileList = []
      this.fileList2 = []
    },
    async getNewsDetails(demand_id) {
      const { data: res } = await this.$http.get(
        `/api/v2/demand/detail/${demand_id}`
      );
      if (res.code !== "200") return this.$message.error(res.msg);
      this.demand_type = res.data.demand_type;
      if (res.data.demand_type == 0) {
        this.needsForm.title = res.data.title;
        this.needsForm.end_time = res.data.end_time;
        // this.needsForm.phone = res.data.phone;
        // this.needsForm.main_image =  res.data.main_image.split(",");
        // this.fileList =  this.needsForm.main_image.map((item) => {
        //   let a = {
        //     url: item,
        //   };
        //   return a;
        // });
        this.listToArr(res.data.main_image,1);
        // console.log(this.needsForm.main_image);
        this.needsForm.params = JSON.parse( res.data.param);
      } else {
        this.saleForm.addr = res.data.addr;
        this.saleForm.title = res.data.title;
        this.saleForm.end_time = res.data.end_time;
        // this.saleForm.phone = res.data.phone;
        // this.saleForm.main_image =  res.data.main_image.split(",");
        // this.saleForm.main_image = this.saleForm.main_image.split(",");
        // this.fileList2 = this.saleForm.main_image.map((item) => {
        //   let a = {
        //     url: item,
        //   };
        //   return a;
        // });
        this.listToArr(res.data.main_image,2);

        console.log(res.data);
        console.log(res.data.main_image);
        console.log(this.fileList2);
        this.saleForm.params = JSON.parse(res.data.param);
      }

      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },

    async pubilsh(th) {
      if (th == 0) {
        this.needsForm.main_image=this.fileList.map((item) => {
          return item.url
        });
        let needsFormJson = {
          main_image: this.listToString(this.fileList),
          param: JSON.stringify(this.needsForm.params),
          member_id: this.user_id,
          demand_type: 0,
          title: this.needsForm.title,
          end_time: this.needsForm.end_time,
          // phone: this.needsForm.phone,
          demand_id: this.demand_id,
        };
        const { data: res } = await this.$http.post(
          `/api/v2/demand/editaddDemand`,
          needsFormJson
        );
        if (!res.sucess) return this.$message.error("失敗");
        this.$message.success("修改成功");
        this.dialogVisible = false;
        this.getNeedList();
      } else {
        this.saleForm.main_image=this.fileList2.map((item) => {
          return item.url
        });
        let saleFormJson = {
          demand_type: 1,
          addr: this.saleForm.addr,
          main_image: this.listToString(this.fileList2),
          param: JSON.stringify(this.saleForm.params),
          member_id: this.user_id,
          title: this.saleForm.title,
          end_time: this.saleForm.end_time,
          // phone: this.saleForm.phone,
          demand_id: this.demand_id,
        };
        // this.saleForm.main_image = this.saleForm.main_image.toString();
        // this.saleForm.param = JSON.stringify(this.saleForm.params);
        // console.log(JSON.stringify(this.saleForm.param));
        // this.saleForm.member_id = this.user_id;
        // this.saleForm.demand_id = this.demand_id;
        // console.log(this.saleForm);
        const { data: res } = await this.$http.post(
          `/api/v2/demand/editaddDemand`,
          saleFormJson
        );
        if (!res.sucess) return this.$message.error("失敗");
        this.$message.success("修改成功");
        this.dialogVisible = false;
        this.getNeedList();
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList;
    },
    handlePictureCardPreview(file) {
      // this.dialogImageUrl = file.url;
      // this.dialogVisible = true;
    },
    handleLogoSuccess(res, file) {
      // console.log(file)
      // console.log(res)
      // this.fnUploadFile(file.raw);
      this.fileList.push({
        name: res.key,
        url: this.$imgUrl+ res.key,
      });
    },
    handleChange(file, fileList) {
      console.log("ssss===", fileList);
      // this.fileList = fileList.slice(-3);
    },
    beforeAvatarUpload(file) {
      // console.log('文件大小======',file)
      const isPNG = file.type === "image/png";
      const isJPEG = file.type === "image/jpeg";
      const isJPG = file.type === "image/jpg";
      const isLt6M = file.size / 1024 / 1024 < 20;

      if (!isPNG && !isJPEG && !isJPG) {
        this.$message.error("上傳圖片只能是jpg、png、jpeg格式!");
        return false;
      }
      if (!isLt6M) {
        this.$message.error("上傳圖片大小不能超過 20MB!");
        return false;
      }
    },
    //上传图片至七牛云
    fnUploadFile(raw, th) {
      let vm = this;
      let key = "avatar_" + Date.now() + "_" + Math.random();
      let file = raw;
      var putExtra = {
        fname: key,
        mimeType: ["image/png", "image/jpeg", "image/gif"], //限制上传类型
      };
      let config = {
        useCdnDomain: true,
        region: qiniu.region.z0,
        forceDirect:true
      };
      let observer = {
        next(res) {
          // ...
        },
        error(err) {
          // console.log('失败====',err);
        },
        complete(res) {
          // console.log('上传图片====',JSON.stringify(res))
          let img = {
            name: key,
            url: vm.$imgUrl + res.key,
          };
          vm.fileList.push(img);
          // console.log(vm.fileList)
        },
      };
      var observable = qiniu.upload(file, key, this.qn.token, putExtra, config);
      var subscription = observable.subscribe(observer); // 上传开始
    },
    handleRemove2(file, fileList) {
      console.log(file, fileList);
      this.fileList2 = fileList;
    },
    handlePictureCardPreview(file) {
      // this.dialogImageUrl = file.url;
      // this.dialogVisible = true;
    },
    handleLogoSuccess2(res, file) {
      // console.log(file)
      // console.log(res)
      // this.fnUploadFile2(file.raw);
      this.fileList2.push({
        name: res.key,
        url: this.$imgUrl+ res.key,
      });
    },
    handleChange2(file, fileList) {
      console.log("ssss===", fileList);
      // this.fileList = fileList.slice(-3);
    },
    beforeAvatarUpload2(file) {
      // console.log('文件大小======',file)
      const isPNG = file.type === "image/png";
      const isJPEG = file.type === "image/jpeg";
      const isJPG = file.type === "image/jpg";
      const isLt6M = file.size / 1024 / 1024 < 20;

      if (!isPNG && !isJPEG && !isJPG) {
        this.$message.error("上傳圖片只能是jpg、png、jpeg格式!");
        return false;
      }
      if (!isLt6M) {
        this.$message.error("上傳圖片大小不能超過 20MB!");
        return false;
      }
    },
    //上传图片至七牛云
    fnUploadFile2(raw, th) {
      let vm = this;
      let key = "avatar_" + Date.now() + "_" + Math.random();
      let file = raw;
      var putExtra = {
        fname: key,
        mimeType: ["image/png", "image/jpeg", "image/gif"], //限制上传类型
      };
      let config = {
        useCdnDomain: true,
        region: qiniu.region.z0,
        forceDirect:true
      };
      let observer = {
        next(res) {
          // ...
        },
        error(err) {
          // console.log('失败====',err);
        },
        complete(res) {
          // console.log('上传图片====',JSON.stringify(res))
          let img = {
            name: key,
            url: vm.$imgUrl + res.key,
          };
          vm.fileList2.push(img);
          // console.log(vm.fileList)
        },
      };
      var observable = qiniu.upload(file, key, this.qn.token, putExtra, config);
      var subscription = observable.subscribe(observer); // 上传开始
    },
     // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = "";
      separator = separator || ",";
      for (let i in list) {
        strs += list[i].url + separator;
      }
      return strs != "" ? strs.substr(0, strs.length - 1) : "";
    },
    listToArr(val,th){
      if (val) {
          // 首先将值转为数组
          const list = Array.isArray(val) ? val : val.split(",");
          // 然后将数组转为对象数组
          if(th==1){
            this.fileList = list.map((item) => {
              if (typeof item === "string") {
                item = { name: item, url: item };
              }
              return item;
            });
          }else{
            this.fileList2 = list.map((item) => {
            if (typeof item === "string") {
              item = { name: item, url: item };
            }
            return item;
          });
          }
          
        } else {
          if(th==1){
          this.fileList = [];

          }else{
          this.fileList2 = [];

          }
          return [];
        }
    },
    async getQiniuToken() {
      const { data: res } = await this.$http.get(`/api/v2/qiniu/getUptoken`);
      if (!res.sucess) return this.$message.error("獲取失敗");
      this.qn.token = res.data;
      // console.log("七牛云=====", res);
    },
  },
  created() {
    if (this.user_id) {
      this.getNeedList();
    }
    this.getQiniuToken();
  },
};
</script>

<style lang="less" scoped>
.need-list {
  flex: 1;
  margin-left: 10px;
}
.news_item {
  display: flex;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 20px;
  .el-image {
    width: 100%;
    // height: auto;
    height: 220px;
    object-fit: cover;
    border-radius: 8px 8px 0 0;
  }
  .news_item_info {
    padding: 10px 15px 15px;
    height: 93px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: -webkit-fill-available;
    h3 {
      font-size: 22px;
      line-height: 34px;
      margin-bottom: 10px;
      font-family: MicrosoftYaHei;
      color: #222222;
      font-weight: 400;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .news_item_time {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      color: #333333;
      margin-right: 27px;
      font-family: MicrosoftYaHei;
      color: #888888;
      font-weight: 400;
    }
    .news_item_desc {
      font-size: 14px;
      color: #414141;
      line-height: 22px;
      margin-top: 23px;
    }
    .el-icon-view:before {
      margin-right: 5px;
    }
    .types {
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #007aff;
      line-height: 17px;
    }
    .red {
      color: #ff3b30;
    }
  }
  .edit-btn {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    button {
      background: #20317f;
      border-radius: 4px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 22px;
      padding: 12px 36px;
      border: none;
      cursor: pointer;
    }
    .del {
      background: #f2f2f2;
      color: #aaaaaa;
    }
  }
}
.needs-form {
  .el-row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .tips {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff3b30;
      line-height: 20px;
      // margin-top: 10px;
      margin-left: 10px;
    }
    .el-col-3 {
      padding-left: 10px;
    }
  }
  .tag {
    position: relative;
    i {
      position: absolute;
      left: -12px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ff3b30;
      line-height: 22px;
    }
  }
  .el-upload {
    width: 100px;
    height: 100px;
    line-height: 106px;
    margin-bottom: 10px;
    background: #fff;
    border: 1px dashed #aeaeb2;
    border-radius: 8px;
    i {
      color: #2c2c2e;
      font-weight: bolder;
    }
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
  }
  .el-dialog__wrapper {
    z-index: 2012;
  }
}
.el-button {
  width: 100%;
  font-size: 14px;
  color: #878787;
  line-height: 22px;
  padding: 10px 0;
  background: #fbfbfb;
  border: none;
  margin-bottom: 10px;
}

@media screen and (max-width: 768px) {
  .news_item {
    padding: 5px 20px;
    margin-left: 0;
    .el-image {
      width: 120px;
      height: 75px;
      margin-right: 12px;
      border-radius: 8px;
    }
    .news_item_info {
      h3 {
        font-size: 16px;
        line-height: 28px;
        color: #000;
        margin-bottom: 5px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
      .news_item_time {
        font-size: 12px;
        color: #333333;
        margin-right: 10px;
      }
    }
  }
  .el-button {
    width: 80%;
    font-size: 14px;
    color: #878787;
    line-height: 22px;
    padding: 10px 0;
    background: #fbfbfb;
    border: none;
    margin: 10px auto;
    display: block;
  }
}
/deep/.el-progress-circle {
  width: 90px !important;
  height: 90px !important;
}
</style>
<style>
/* .v-modal{
  display: none;
} */
.el-upload-list--picture-card .el-upload-list__item-thumbnail {
  object-fit: contain;
}
.el-upload-list--picture-card .el-progress {
  width: 90px !important;
}
</style>
